import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {


  constructor(private vcr: ViewContainerRef,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastsManager) {
    this.route.queryParams.subscribe(params => {
      this.toastr.setRootViewContainerRef(vcr);
      const accountType = params['accType'];
      if (accountType === 'n') {
        toastr.success('Welcome to creative allies');
      }
    });
  }

  title = 'Creative Allies';

  ngOnInit() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts